// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__JT59Q","info":"Note_info__IYMwW","note":"Note_note__3k9UI","actions":"Note_actions__3DLND"};